<template>
  <div class="projects-figuration">
    <violet-bar>Affichage (ou non) des projets</violet-bar>
    <div class="box squarebox" v-if="projects_map && !projects_need_upgrade && run">
      <table class="table is-small is-striped is-hoverable is-bordered">
        <thead>
          <td>Nom du projet</td>
          <td>Présence dans l'index</td>
          <td>Présence dans les axes</td>
          <td>Présence d'une page complète</td>
        </thead>
        <tr v-for="project in projects" :key="project.id">
          <td>{{project.name}}</td>
          <td><input type="checkbox" class="checkbox" v-model="projects_map[project.id].index"></td>
          <td><input type="checkbox" class="checkbox" v-model="projects_map[project.id].axes"></td>
          <td><input type="checkbox" class="checkbox" v-model="projects_map[project.id].page"></td>
        </tr>
      </table>
    </div>
    <div
      class="button button is-primary"
      :class="{ 'is-loading': loading }"
      @click="save"
    >
      Enregistrer
    </div>
  </div>
</template>
<script>
import VioletBar from "../Projects/VioletBar";
import { types as misc_types } from "../../store/actions/misc";
import { types as project_types } from "../../store/actions/projects";

export default {
  name: "projects_figuration",
  components: { VioletBar },
  data() {
    return {
      loading: false,
      projects: [],
      projects_map: null,
      foo: "bar",
      run: 0,
    };
  },
  computed: {
    projects_need_upgrade() {
      const vals = Object.values(this.projects_map);
      if (vals.length === 0) return false;
      return typeof vals[0] === "boolean";
    }
  },
  methods: {
    async fetch() {
      this.projects = await this.$store.dispatch(project_types.GET_PROJECTS);
      try {
        this.projects_map = await this.$store.dispatch(
          misc_types.GET_META_PROJECTS
        );
        this.projects.forEach((pro) => {
          if (typeof this.projects_map[pro.id] === "undefined") {
            this.projects_map[pro.id] = { index: false, axes: false, page: false };
          }
        });
        
        this.$nextTick(() => {
          if (this.projects_need_upgrade) {
            this.upgrade_projects();
            this.run = 1;
          } else {
            this.run = 1;
          }
        });
      } catch (e) {
        this.projects_map = this.projects
          .map(a => a.id)
          .reduce((out, id) => {
            out[id] = { index: false, axes: false, page: false };
            return out;
          }, {});
      }
    },
    upgrade_projects() {
      const entries = Object.entries(this.projects_map);
      this.projects_map = entries.reduce((out, [k, v]) => {
        out[k] = { index: v, axes: v, page: v };
        return out;
      }, {});
    },
    async save() {
      this.loading = 1;
      await this.$store.dispatch(
        misc_types.SET_META_PROJECTS,
        this.projects_map
      );
      this.loading = 0;
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>
